<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>تصویر</th>
                    <th>کفش</th>
                    <th>زمین</th>
                    <th>تعداد برد مورد نیاز</th>
                    <th>وضعیت</th>
                    <th>دیفالت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="boot in boots" :key="boot._id">
                    <td>
                      <img
                        v-if="boot.imageUrl"
                        :src="boot.imageUrl"
                        alt=""
                        style="max-height: 40px; max-width: 60px; object-fit: contain;"
                      />
                      <span v-else>-</span>
                    </td>
                    <td>{{ boot.BootName }}</td>
                    <td>{{ boot.BootGround ? boot.BootGround.groundName : 'دیفالت' }}</td>
                    <td>{{ boot.minWinToAchieve }}</td>
                    <td>{{ boot.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>{{ boot.isDefault ? 'اصلی' : 'فرعی' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/boot', query: { id: boot._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bootService from '../../../../services/boot';
export default {
  name: 'boots',
  data() {
    return {
      boots: [],
    };
  },
  created() {
    this.getboots();
  },
  methods: {
    async getboots() {
      try {
        const condition = {};
        const resData = await bootService.allBoots(condition);
        console.log(resData);
        this.boots = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
